import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { setOrderData } from "../../actions/orderActions";
import moment from "moment";

const AdminOrderListRow = ({ current, i }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  // console.log(current, "current ............");

  return (
    <>
      <tr key={i}>
        <td>{current?.orderNo}</td>
        <td>{current?.userId?.firstName + " " + current?.userId?.lastName}</td>
        {auth?.user?.role === "superAdmin" && <td>{current?.storeId?.name}</td>}
        <td>
          {moment(current?.date).format("MM/DD/YYYY") +
            " - " +
            moment(current?.date).format("h:mm A")}
        </td>
        <td>{current?.totalAmount} $</td>
        <td
          style={{
            maxWidth: "200px",
            whiteSpace: "normal",
            overflow: "hidden",
            textOverflow: "ellipsis",
            cursor: "pointer",
          }}
        >
          {current?.address?.address}
        </td>
        {/* <td>Home</td> */}
        <td>{current?.status}</td>
        <td>
          {/* <Link> */}
          <Link to={`/order-details/${current?.id}`}>
            <button
              className="btn btn-primary btn-sm"
              // onClick={() => {
              //   dispatch(setOrderData(current));
              //   // Navigate to the details page
              //   // navigate(`/order-details/${current.id}`);
              // }}
            >
              View
            </button>
          </Link>
        </td>
      </tr>
    </>
  );
};
export default AdminOrderListRow;
